import type { LocalVariant } from "@features/products/helpers/variantHelpers";
import { createAction } from "@redux/actions/actionCreators";

const [useSetProductVariants, setProductVariants] = createAction<{
  productUuid: string;
  variants: LocalVariant[];
}>("product/setVariants");

export default useSetProductVariants;
export { setProductVariants };
